export const status = [
  'A faire',
  'En cours',
  'Terminé',
  'Suspendu',
  'En attente',
]

export const etats = ['En attente', 'Validé', 'Rejeté']
export const priorityLabels: { [key: number]: string } = {
  1: 'Critique',
  2: 'Élevé',
  3: 'Moyen',
  4: 'Faible',
}

export const priorityLabelsTranslations: { [key: number]: string } = {
  1: 'Critical',
  2: 'High',
  3: 'Medium',
  4: 'Low',
}

// constants.ts
export type Language = 'en' | 'fr'

export const maturiteLabels: { [key: string]: { en: string; fr: string } } = {
  '1': { en: 'Initiation', fr: 'Initiation' },
  '2': { en: 'Definition', fr: 'Définition' },
  '3': { en: 'Integration', fr: 'Intégration' },
  '4': { en: 'Management', fr: 'Management' },
  '5': { en: 'Optimization', fr: 'Optimisation' },
}

export const TypeProjet = [
  'Gouvernance du SI',
  'Gestion de la sécurité du SI',
  'Organisationnel / Processus',
  'Opérationnel',
  'Physique',
  'IT / ISD',
  'IT / Métier',
  'Autres',
]

interface TypeActionTranslations {
  [key: string]: string
}
export const TypeAction = [
  'Gouvernance',
  'Organisationnel',
  'Opérationnel',
  'Physique',
  'IT',
]

export const TypeActionTranslations: TypeActionTranslations = {
  Gouvernance: 'Governance',
  Organisationnel: 'Organizational',
  Opérationnel: 'Operational',
  Physique: 'Physical',
  IT: 'IT',
}

export const ControlNature = [
  'Équipement réseau',
  'Equipment de sécurité',
  'Serveur',
  'Application',
  'Service',
  'Compte',
  'Processus & Documentation',
  'Humain',
  'Autres',
]

export const IncidentTypes = [
  'Intrusion',
  'Déni de service',
  'Compromission',
  'Divulgation des données',
  'Exécution de code à distance',
  'Corruption',
]

export const IncidentPerimeter = [
  'Réseau',
  'Serveurs',
  'Applications Internes',
  'DMZ',
  'Applications Cloud',
  'Pc',
]

export const PriorityTypes = ['1', '2', '3', '4']
export enum SymboleRasci {
  RESPONSIBLE = 'Responsable',
  APPROVER = 'Approbateur',
  SUPPORT = 'Support',
  VIEWED = 'Consulté',
  INFORMED = 'Informé',
}
